import { render, staticRenderFns } from "./ContainerWithScrollProp.vue?vue&type=template&id=02a23ff6&"
import script from "./ContainerWithScrollProp.vue?vue&type=script&lang=ts&"
export * from "./ContainerWithScrollProp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02a23ff6')) {
      api.createRecord('02a23ff6', component.options)
    } else {
      api.reload('02a23ff6', component.options)
    }
    module.hot.accept("./ContainerWithScrollProp.vue?vue&type=template&id=02a23ff6&", function () {
      api.rerender('02a23ff6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/ContainerWithScrollProp.vue"
export default component.exports